/**
 * Backlinks functionality - displaying roles that reference the current role
 */

import { apiGet } from '../utils/apiClient.js';
import { t } from '../utils/i18n.js';

type BacklinksResponse = {
    referencedBy: Array<{ id: number; name: string }>;
};

/**
 * Load and display backlinks (roles that reference this role)
 * @param attachRoleReferenceHandlers - Callback to attach click handlers to role references
 */
export async function loadAndDisplayBacklinks(
    roleId: number,
    attachRoleReferenceHandlers: () => void
): Promise<void> {
    if (!Number.isFinite(roleId)) return;

    try {
        const data = await apiGet<BacklinksResponse>(`/api/roles/${roleId}/references`);
        const referencedBy = data.referencedBy || [];
        
        // Find the referenced tab container
        const panelContent = document.querySelector('.role-panel__content');
        if (!panelContent) return;
        
        const backlinksList = panelContent.querySelector('#backlinks-list');
        if (!backlinksList) return;
        
        // Clear loading state
        backlinksList.innerHTML = '';
        
        if (referencedBy.length === 0) {
            const empty = document.createElement('p');
            empty.className = 'role-panel__empty-state';
            empty.textContent = t('panel.referenced.none');
            backlinksList.appendChild(empty);
            return;
        }
        
        // Create list of backlinks
        const backlinkList = document.createElement('ul');
        backlinkList.className = 'role-panel__backlink-list';
        
        referencedBy.forEach(role => {
            const li = document.createElement('li');
            const span = document.createElement('span');
            span.className = 'role-reference role-link';
            span.dataset.roleId = String(role.id);
            span.textContent = role.name;
            li.appendChild(span);
            backlinkList.appendChild(li);
        });
        
        backlinksList.appendChild(backlinkList);
        
        // Attach click handlers to the new backlink references
        attachRoleReferenceHandlers();
    } catch (error) {
        console.error('Failed to load backlinks:', error);
    }
}
